export const ADMIN_RANKS = {
  A: "A",
  B: "B",
  C: "C",
  GP: "GP",
  CL: "CL",
  CAISSE: "CAISSE",
  FULL: "FULL",
};

export function getAdminRanks(user) {
  const rawRanks = user?.admin_rank;
  const ranks = Array.isArray(rawRanks)
    ? rawRanks.flatMap((rank) => String(rank).replace(/;/g, ",").split(","))
    : typeof rawRanks === "string"
      ? rawRanks.replace(/;/g, ",").split(",")
      : [];

  return [...new Set(ranks.map((rank) => String(rank).trim().toUpperCase()).filter(Boolean))];
}

export function hasAdminRank(user, ...ranks) {
  if (user?.role !== "admin") return false;
  const userRanks = getAdminRanks(user);
  return userRanks.includes(ADMIN_RANKS.FULL) || ranks.some((rank) => userRanks.includes(rank));
}

export function hasExplicitAdminRank(user, rank) {
  return user?.role === "admin" && getAdminRanks(user).includes(rank);
}

export function hasFullAdminRank(user) {
  return user?.role === "admin" && getAdminRanks(user).includes(ADMIN_RANKS.FULL);
}

export function isFounderAccount(user) {
  return user?.role === "admin" && user?.id === "ARTICO002";
}

export function isCashAccount(user) {
  return user?.role === "admin" && user?.id === "ARTICO003";
}

export function canAccessCashPages(user) {
  return isFounderAccount(user) || isCashAccount(user);
}
